import { AmbientGlow, ScrollReveal } from '@/components/design-system';
import PageShell from '@/components/layout/PageShell';
import NearbyActivityMap from '@/components/map/NearbyActivityMap';

/** Household-facing map: open listings + active community drives near the signed-in household's set city. */
export function MapPage() {
  return (
    <PageShell>
      <div className="container relative py-8">
        <AmbientGlow color="primary" size={380} position="top-0 right-0 translate-x-1/3 -translate-y-1/3" />
        <AmbientGlow color="accent" size={340} position="bottom-0 left-0 -translate-x-1/3 translate-y-1/3" />

        <ScrollReveal className="relative mb-6">
          <span className="text-overline">Recovery Map</span>
          <h1 className="font-heading mt-1 text-3xl font-bold text-foreground sm:text-4xl">Nearby activity</h1>
        </ScrollReveal>

        <ScrollReveal delay={0.08} className="relative">
          <NearbyActivityMap />
        </ScrollReveal>
      </div>
    </PageShell>
  );
}

export default MapPage;
